import { ArrowUpRight, Heart, Mail, Menu, X } from "lucide-react";
import { useState } from "react";
import { contactDetails } from "../data/moselcars";

const navItems = [
  ["Fahrzeuge", "/fahrzeuge", "bestand"],
  ["Berater", "/#berater", "berater"],
  ["Über uns", "/#ueber-uns", "ueber-uns"],
  ["Finanzierung", "/#finanzierung", "finanzierung"],
  ["Ankauf", "/#ankauf", "ankauf"],
  ["Kontakt", "/#kontakt", "kontakt"]
];

export default function SiteHeader({ favoriteCount, favoriteAlerts = 0, onOpenFavorites, onNavigate, currentPath }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const handleNav = (event, href) => {
    event.preventDefault();
    closeMenu();
    onNavigate(href);
  };
  const favoritesLabel = favoriteCount === 1 ? "Merkliste, 1 Fahrzeug" : `Merkliste, ${favoriteCount} Fahrzeuge`;

  return (
    <header className="site-header">
      <div className="page-shell header-inner">
        <a className="brand-lockup" href="/" data-testid="brand-home-link" onClick={(event) => { event.preventDefault(); closeMenu(); onNavigate("/"); }}>
          <span className="brand-name">Moselcars</span>
          <span className="brand-subline">Atelier &amp; Collection</span>
        </a>
        <nav className="desktop-nav" aria-label="Hauptnavigation">
          {navItems.map(([label, href, key]) => <a key={key} href={href} className={href === currentPath ? "is-current" : ""} aria-current={href === currentPath ? "page" : undefined} onClick={(event) => handleNav(event, href)} data-testid={`header-nav-${key}-link`}>{label}</a>)}
        </nav>
        <div className="header-actions">
          <a className="header-phone" href={`mailto:${contactDetails.email}`} data-testid="header-email-link">
            <Mail size={15} strokeWidth={1.5} />
            <span>{contactDetails.email}</span>
          </a>
          <button className={`header-favorites ${favoriteCount ? "has-items" : ""}`} type="button" aria-label={favoritesLabel} onClick={() => { closeMenu(); onOpenFavorites(); }} data-testid="header-favorites-button">
            <Heart size={16} strokeWidth={1.5} fill={favoriteCount ? "currentColor" : "none"} />
            <span className="header-favorites-label">Merkliste</span>
            {favoriteCount > 0 && <span className="header-favorites-count" data-testid="header-favorites-count">{favoriteCount}</span>}
            {favoriteAlerts > 0 && <span className="header-favorites-alert" title={`${favoriteAlerts} Änderungen in der Merkliste`} data-testid="header-favorites-alert" />}
          </button>
          <a className="header-request" href="/#kontakt" data-testid="header-request-button">
            Anfrage <ArrowUpRight size={15} strokeWidth={1.5} />
          </a>
          <button className="mobile-menu-button" type="button" aria-label={menuOpen ? "Menü schließen" : "Menü öffnen"} aria-expanded={menuOpen} onClick={() => setMenuOpen((current) => !current)} data-testid="header-menu-button">
            {menuOpen ? <X size={21} strokeWidth={1.5} /> : <Menu size={21} strokeWidth={1.5} />}
          </button>
        </div>
        {menuOpen && (
          <div className="mobile-menu" data-testid="mobile-navigation-menu">
            {navItems.map(([label, href, key]) => <a key={key} href={href} onClick={(event) => handleNav(event, href)} data-testid={`mobile-nav-${key}-link`}>{label}<ArrowUpRight size={15} strokeWidth={1.5} /></a>)}
            <button className="mobile-menu-favorites" type="button" onClick={() => { closeMenu(); onOpenFavorites(); }} data-testid="mobile-favorites-button"><Heart size={15} /> Merkliste{favoriteCount ? ` (${favoriteCount})` : ""}{favoriteAlerts > 0 && <span className="header-favorites-alert" data-testid="mobile-favorites-alert" />}</button>
            <a className="mobile-menu-phone" href={`mailto:${contactDetails.email}`} onClick={closeMenu} data-testid="mobile-email-link"><Mail size={15} /> {contactDetails.email}</a>
          </div>
        )}
      </div>
    </header>
  );
}
